import type { FashionOrderFormValues } from './fashionOrder.schema'

export const FILE_SIZE_LIMIT = 200 * 1024 * 1024

export const createFashionOrderDefaults = (): FashionOrderFormValues => ({
  supplier: '',
  supplierId: undefined,
  supplierDetails: undefined,
  seller: '',
  sellerId: undefined,
  sellerDetails: undefined,
  client: '',
  clientId: undefined,
  clientDetails: undefined,
  carrier: { id: 0, companyName: '' },
  orderType: '',
  orderTypeId: undefined,
  representativeId: undefined,
  representativeName: '',
  orderSituationId: undefined,
  orderSituationName: '',
  generalClassId: undefined,
  generalClassName: '',
  billingDate: '',
  clientOrderNumber: undefined,
  sellingPrice: undefined,
  paymentConditionId: undefined,
  paymentConditionName: '',
  paymentMethodId: undefined,
  paymentMethodName: '',
  shippingTypeId: undefined,
  shippingTypeName: '',
  trackingCode: '',
  orderDate: new Date().toISOString().split('T')[0],
  deliveryDate: '',
  criticalAnalysis: false,
  criticalAnalysisDesc: '',
  extraInfo: '',
  quantityItems: '0',
  quantityPieces: '0',
  totalCost: 'R$ 0,00',
  deliveryTime: '',
  shippingCost: '',
  maximumBillingAmount: '',
  installments: [],
})
